export const BROWSE = '/browse';
export const HOME = '/';
export const AUTHENTICATION = '/authenticate';
export const LEARNING = '/learning';
export const CONTACT = '/contact';
export const ABOUT = '/about';
export const COMMUNITY = '/community';
//BROWSE
export const USERDETAILS = '/user-details';
export const USERHOME = '/user-home';
export const USERQUESTIONS = '/user-questions';
export const USERANSWERS = '/user-answers';
export const USERBADGES = '/user-bagde';
export const HELPSUPPORT = '/help';
export const HELPSUPPORTALTER = '/help-&-support-center';
export const WHYUS = '/why-collegearia?';
export const OURMOTTO = '/our-motto';
//LEARNING
export const REACT = '/learn-react';
export const FULLSTACK = '/roadmap-to-full-stack-developer';
export const CSS = '/learn-css';
export const JS = '/learn-js';
//COMUNITY
export const OURTEAM = '/our-team';
export const IDEA = '/idea';
export const INNOVATION = '/innovation';
//CONTACT
export const LEAVECOMMENT = '/leave-a-comment';
export const EMAIL = '/email-us';
export const JOIN = '/join-us';
//ABOUT
export const TECHS = '/techs-used';
export const PLANS = '/plans';
export const ROADMAP = '/roadmap';
